import AdminConfigModel from '../../../models/AdminConfigModel';

export default function getInitialConfigList() {
  try {
    let _return = [];

    for (let index = 1; index <= 47; index++) {
      let _default = getDefaultValue(index);

      _return.push(AdminConfigModel({
        id: 0,
        fieldId: index,
        value: _default
      }));
    }

    return _return;

  } catch (error) {
    console.log('Error getInitialConfigList', error);
    throw error;
  }

  function getDefaultValue(i = 0) {
    let _return = '';

    switch (i) {
      case 3:
        _return = '#456091';
        break;
      case 4:
        _return = '#ffffff';
        break;
      case 5:
        _return = '#ffffff';
        break;
      case 6:
        _return = '#000000';
        break;
      case 7:
        _return = 'false';
        break;
      case 8:
        _return = '1';
        break;
      default:
        break;
    }

    return _return;
  }
}
